import { createSelector, OutputSelector } from 'reselect'
import { ICoverResponseData } from 'apps/booking/types'
import { IStore } from 'apps/booking/utils/reducers'

export const isCoverLoadModalOpen = (state: IStore): boolean =>
  state.ui.dialogOpen && state.ui.dialogId === 'coverFlow'

export const selectCoverLoad = (state: IStore): ICoverResponseData | undefined =>
  state.coverLoad.data

export const selectCoverLoadIsLoading = (state: IStore) => state.coverLoad.loadingCreate

export const selectAssignDriverIsLoading = (state: IStore) => state.coverLoad.loadingUpdate

interface SelectCoverLoadSuccess
  extends OutputSelector<IStore, boolean, (res1: ICoverResponseData, res2: boolean) => boolean> {}

export const selectCoverLoadSuccess: SelectCoverLoadSuccess = createSelector(
  [selectCoverLoad, selectCoverLoadIsLoading],
  (response, isLoading) => Boolean(response) && !isLoading
)

export const selectAssignedDriverSuccess = createSelector(
  [selectCoverLoad, selectCoverLoadSuccess],
  (response, isSuccess) => isSuccess && Boolean(response?.driver?.id)
)

export const selectCoverLoadError = (state: IStore) => state.coverLoad.error

export const selectCoverloadNoteSubmitSuccess = (state: IStore) => state.notes.isSuccess
